module.exports = __webpack_public_path__ + "static/img/Video03.804a676.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/Video03.jpg
// module id = PXwf
// module chunks = 0